export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11528.b90349a2.jpg";